import { Component } from '@angular/core';
import {ITableCellItem} from "../../../../../shared/shared/table/table-cell";
import {ITableColumn} from "../../../../../shared/shared/table/table-column";
import {IDocumentDto} from "../../../dto/document-listing.dto";

@Component({
  selector: 'app-latest-acitivty-column',
  templateUrl: './latest-acitivty-column.component.html',
  styleUrl: './latest-acitivty-column.component.scss'
})
export class LatestAcitivtyColumnComponent implements ITableCellItem {
  dataItem: IDocumentDto;
  columnOptions: ITableColumn;

  get latestActivity():string{
      const ts = this.dataItem?.status_updated_at || this.dataItem.updated_at || "";
      return ts.split('.')[0];
  }
}